'use client'

import { useState } from 'react'
import { ContentfulLivePreview } from '@contentful/live-preview'

import { Button } from '../../components/button'
import { Dialog } from '../../components/dialog'
import { RichText } from '../helper-components/rich-text'

interface DisclaimerProps {
  id: string
  buttonText: string
  dialogText: string | any
}

export const DisclaimerDialogCms = (props: DisclaimerProps) => {
  const [open, setOpen] = useState(false)
  return (
    <div className=" flex items-center justify-center bg-[#272752] py-2 text-white md:justify-end">
      <Button
        className="font-normal italic"
        variant="link"
        onClick={() => setOpen(true)}
      >
        <span
          {...ContentfulLivePreview.getProps({
            entryId: props.id,
            fieldId: 'buttonText',
            locale: 'en-us',
          })}
        >
          {props.buttonText}
        </span>
      </Button>
      <Dialog
        isOpen={open}
        onClose={() => setOpen(false)}
        title={props.buttonText}
        hideTitle
        noPadding
      >
        <div className="px-6 pb-16 md:px-40">
          <RichText
            json={props.dialogText.json}
            links={props.dialogText?.links}
            {...ContentfulLivePreview.getProps({
              entryId: props.id,
              fieldId: 'dialogText',
              locale: 'en-us',
            })}
          />
        </div>
      </Dialog>
    </div>
  )
}
